import { TitleWrapper } from './styles'

export const config = {
  title: (
    <>
      Modsen <TitleWrapper>Cloud</TitleWrapper> integration services
    </>
  ),
  subtitle:
    'A team of dedicated Cloud computing experts will join your project at any development stage. We will promptly assess the current situation and relevant tasks to launch the active development phase right away.',
  config: [
    {
      id: 1,
      title: 'Software development',
      text: 'Modsen senior-level specialists help businesses broaden their horizons by launching premium-quality non-server apps. Get an agile custom product with high data storage capacity.',
      imagePath: '/images/interfaces-from-scratch.webp',
      alt: 'Software development',
      imageWidth: 284,
      imageHeight: 116,
      imageTitle: 'Software development',
    },
    {
      id: 2,
      title: 'Product consultation',
      text: 'Our team will qualitatively evaluate your cloud infrastructure and optimize the resources based on the research insights. We know how to improve product safety and enhance the existing infrastructure.',
      imagePath: '/images/interface-consultations.webp',
      alt: 'DevOps product consultation',
      imageWidth: 286,
      imageHeight: 116,
      imageTitle: 'DevOps product consultation',
    },
    {
      id: 3,
      title: 'Cloud migration',
      text: 'Modsen engineers effectively transfer businesses to new infrastructures. The Cloud migration process will be performed safely and qualitatively regardless of the amount of data transferred.',
      imagePath: '/images/cloud-migration.webp',
      alt: 'Cloud migration',
      imageWidth: 297,
      imageHeight: 116,
      imageTitle: 'Cloud migration',
    },
  ],
}
